<template>
	<div class="modal modal-version-downloads">
		<h1 class="text-2xl">Preuzimanje verzija</h1>
		<hr class="mb-1" />
		<label class="text-xs text-primary mb-4"
			><b>NAPOMENA</b>: Izborom verzije preuzimanje se otvara u novom tabu.</label
		>
		<div class="modal-content">
			<div
				class="form-item flex flex-row justify-between items-center mb-2"
				v-for="version in versions"
				:key="version.id"
			>
				<div class="w-3/5">
					<h2>Verzija</h2>
					<h1>{{ version.label }}</h1>
				</div>
				<div class="w-2/5 flex flex-row justify-center">
					<button
						class="edit-nick-btn flex flex-row justify-around items-center text-sm"
						style="width: 150px; height: 48px"
						@click="openVersion(version)"
					>
						Preuzmi
						<i class="fas fa-download text-xl"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		versions: {
			type: Array,
			required: true
		}
	},

	methods: {
		openVersion(version) {
			window.open(version.url, '_blank', 'noopener');
		}
	}
};
</script>

<style lang="scss" scoped>
.form-item {
	background-color: rgb(241, 241, 241);
	border-radius: 12px;
	padding: 12px;
	margin-right: 12px;
	flex-direction: row;
}

.modal-content {
	max-height: 600px;
	overflow-y: auto;
}

h2 {
	color: rgb(90, 90, 90) !important;
}
h1 {
	font-size: 1.2rem;
}
</style>
